import React, { lazy } from "react";
import { Route, Switch, Redirect, useLocation } from "react-router-dom";

// lazy page loads
const NotFound = lazy(() => import("../../components/404"));

/*
 * Add all routes specific to unauthenticated (public) users navigating the main app here
 */
const RoutesGuest = props => {
  const location = useLocation();
  return (
    <Route>
      <Switch>
        <Redirect exact from="/home" to="/browse" />
        <Redirect
          from="/login"
          to={{
            pathname: "/signin",
            state: { redirect: location.state?.from }
          }}
        />
        {["/settings", "/orders", "/favorites", "/project"].map((path, i) => {
          return (
            <Redirect
              key={`guest-${i}`}
              from={path}
              to={{
                pathname: "/signin",
                state: {
                  // capture the full requested URL (search + hash), so gated
                  // links with query params or fragments survive the signin
                  redirect:
                    props.location.pathname +
                    props.location.search +
                    props.location.hash,
                  background: location
                }
              }}
            />
          );
        })}
        <Route component={NotFound} />
      </Switch>
    </Route>
  );
};

export default RoutesGuest;
